import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';

@Injectable()
export class Base64 {
    constructor(
        @Inject(PLATFORM_ID)
        private platformId: any
    ) {

    }

    encode(str: string): string {
        if (isPlatformServer(this.platformId)) {
            return Buffer.from(str).toString('base64');
        } else {
            return btoa(str);
        }
    }

    decode(str: string): string {
        if (isPlatformServer(this.platformId)) {
            return Buffer.from(str, 'base64').toString('ascii');
        } else {
            return atob(str);
        }
    }
}